import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ad452e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "drop-overlay"
}
const _hoisted_2 = { class: "drop-overlay-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Drop image to upload", -1))
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "editor-layout" }
const _hoisted_7 = { class: "tabs-row" }
const _hoisted_8 = { class: "preview-container" }
const _hoisted_9 = { class: "image-sidebar" }
const _hoisted_10 = { class: "sidebar-header" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sidebar-title" }, "Images", -1))
const _hoisted_12 = {
  key: 1,
  class: "no-images"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "image-list" }
const _hoisted_15 = ["onDragstart"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "image-filename" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_Markdown = _resolveComponent("Markdown")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", {
    class: "edit-article",
    onDragenter: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onDragEnter && _ctx.onDragEnter(...args))),
    onDragleave: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
    onDragover: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
  }, [
    (_ctx.isDraggingFile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_icon, {
              size: "56",
              color: "white"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-image-plus")
              ]),
              _: 1
            }),
            _hoisted_3
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.isNew ? 'New Article' : 'Edit Article'), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_btn, {
          variant: "outlined",
          onClick: _ctx.cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_btn, {
          color: "primary",
          onClick: _ctx.save,
          loading: _ctx.saving
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save")
          ]),
          _: 1
        }, 8, ["onClick", "loading"]),
        (_ctx.article.status !== 'published')
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              color: "success",
              onClick: _ctx.publish,
              loading: _ctx.publishing
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Publish ")
              ]),
              _: 1
            }, 8, ["onClick", "loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_v_card, { class: "form-card editor-main" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.article.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.article.title) = $event)),
                label: "Title",
                variant: "outlined",
                density: "comfortable"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.article.author,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.article.author) = $event)),
                label: "Author",
                variant: "outlined",
                density: "comfortable"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.article.headlineImage,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.article.headlineImage) = $event)),
                label: "Image URL (optional)",
                variant: "outlined",
                density: "comfortable"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_combobox, {
                modelValue: _ctx.article.tags,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.article.tags) = $event)),
                label: "Tags",
                variant: "outlined",
                density: "comfortable",
                multiple: "",
                chips: "",
                "closable-chips": ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_tabs, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tab) = $event)),
                  class: "mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { value: "edit" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Edit")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "preview" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Preview")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_btn, {
                  icon: "mdi-help-circle-outline",
                  variant: "text",
                  size: "small",
                  href: "https://www.markdownguide.org/cheat-sheet/",
                  target: "_blank",
                  title: "Markdown Cheatsheet"
                })
              ]),
              _createVNode(_component_v_window, {
                modelValue: _ctx.tab,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tab) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "edit" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["editor-drop-zone", { 'is-dragging-over': _ctx.isDraggingOverEditor }]),
                        onDragenter: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onEditorDragEnter && _ctx.onEditorDragEnter(...args))),
                        onDragleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onEditorDragLeave && _ctx.onEditorDragLeave(...args)))
                      }, [
                        _createVNode(_component_v_textarea, {
                          ref: "markdownEditor",
                          modelValue: _ctx.article.markdownContent,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.article.markdownContent) = $event)),
                          label: "Markdown Content",
                          variant: "outlined",
                          rows: "20",
                          class: "markdown-editor"
                        }, null, 8, ["modelValue"])
                      ], 34)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "preview" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Markdown, {
                          source: _ctx.article.markdownContent || ''
                        }, null, 8, ["source"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_v_btn, {
            size: "small",
            color: "primary",
            "prepend-icon": "mdi-upload",
            onClick: _ctx.triggerFileUpload,
            disabled: _ctx.uploading
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Upload ")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createElementVNode("input", {
            ref: "fileInput",
            type: "file",
            accept: "image/*",
            style: {"display":"none"},
            onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleFileInputChange && _ctx.handleFileInputChange(...args)))
          }, null, 544)
        ]),
        (_ctx.uploading)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              "model-value": _ctx.uploadProgress,
              color: "primary",
              class: "mb-3",
              rounded: ""
            }, null, 8, ["model-value"]))
          : _createCommentVNode("", true),
        (_ctx.images.length === 0 && !_ctx.uploading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createTextVNode(" No images yet."),
              _hoisted_13,
              _createTextVNode("Upload or drop an image onto the page. ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
            return (_openBlock(), _createElementBlock("div", {
              key: image.id,
              class: "image-item",
              draggable: "true",
              title: "Drag to editor to insert",
              onDragstart: ($event: any) => (_ctx.onSidebarImageDragStart(image, $event))
            }, [
              _createElementVNode("img", {
                src: `/api/articles/images/${image.id}`,
                class: "image-thumb",
                alt: image.filename
              }, null, 8, _hoisted_16),
              _createElementVNode("span", _hoisted_17, _toDisplayString(image.filename), 1),
              _createVNode(_component_v_btn, {
                icon: "mdi-delete",
                size: "x-small",
                variant: "text",
                color: "error",
                onClick: ($event: any) => (_ctx.deleteImage(image))
              }, null, 8, ["onClick"])
            ], 40, _hoisted_15))
          }), 128))
        ])
      ])
    ])
  ], 32))
}